import React from "react";
import { StyleSheet, Text, RefreshControl, ScrollView } from "react-native";

import { AnalyticsService } from "../../constants/Analytics";
import { FlatList } from "react-native-gesture-handler";

import { OrderContext } from "../../contexts/order/Store";

import OrderGroupCard from "../../components/order/OrderGroupCard";
import FontStyles from "../../constants/FontStyle";
import Colors from "../../constants/Colors";
import OrderRatingModal from "../../components/modals/OrderRatingModal";
import { useNavigation } from "@react-navigation/core";
import { IOrderGroup } from "../../interfaces/order";
import StyledIcon from "../../components/StyledIcon";

const analytics = new AnalyticsService();

function OrderListIndexScreen() {
  const navigation = useNavigation();

  const { state: order_state, action: order_fetch } =
    React.useContext(OrderContext);

  const [refresh, setRefresh] = React.useState(false);
  const onRefresh = () => {
    setRefresh(true);
    order_fetch()
      .then(() => {
        setRefresh(false);
      })
      .catch(() => {
        setRefresh(false);
      });
  };

  const [selectedOrder, setSelectedOrder] = React.useState<null | IOrderGroup>(
    null
  );
  const [isConfirmModalOpen, setConfirmModalOpen] = React.useState(false);

  const hideConfirmModal = () => {
    setConfirmModalOpen(false);
    setSelectedOrder(null);
  };
  const openConfirmModal = (order: IOrderGroup) => {
    setSelectedOrder(order);
    setConfirmModalOpen(true);
  };

  return (
    <>
      {order_state.order_group && order_state.order_group.length ? (
        <FlatList
          initialNumToRender={3}
          data={order_state.order_group}
          renderItem={({ item }) => (
            <OrderGroupCard
              navigation={navigation}
              order={item}
              confirmAction={openConfirmModal}
            />
          )}
          keyExtractor={(item: any) => `${item?._id}`}
          contentContainerStyle={styles.container}
          refreshControl={
            <RefreshControl
              refreshing={refresh}
              onRefresh={() => onRefresh()}
            />
          }
        />
      ) : (
        <ScrollView
          contentContainerStyle={styles.emptyContainer}
          refreshControl={
            <RefreshControl
              refreshing={refresh}
              onRefresh={() => onRefresh()}
            />
          }
        >
          <StyledIcon
            iconName="shopping-bag"
            iconColor={Colors.shades._1}
            iconLibrary="Feather"
            iconOnly
            size={58}
          />
          <Text
            style={{
              ...FontStyles.dark,
              ...FontStyles.size16,
              ...FontStyles.lh20,
              ...FontStyles.bold,
              textAlign: "center",
              marginTop: 8,
            }}
          >
            No order found!
          </Text>
          <Text
            style={{
              color: Colors.shades._7,
              ...FontStyles.size13,
              ...FontStyles.lh18,
              ...FontStyles.normal,
              textAlign: "center",
              marginTop: 10,
            }}
          >
            You have not placed any order.
          </Text>
        </ScrollView>
      )}
      {selectedOrder !== null ? (
        <OrderRatingModal
          modalState={isConfirmModalOpen}
          hideModal={hideConfirmModal}
          order={selectedOrder}
        />
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    // paddingBottom: 10,
    backgroundColor: Colors.shades._5,
    paddingBottom: 100,
  },
  emptyContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 16,
    backgroundColor: Colors.whiteColor,
  },
});

export default OrderListIndexScreen;
